"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("./Accordion");
exports.default = Accordion_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Accordion/index.js
// module id = 919
// module chunks = 8